import request from '@/utils/request'

export const getPermissionCatalog = () =>
  request({ url: '/api/permissions/catalog', method: 'get' })

export const getRoles = () =>
  request({ url: '/api/roles', method: 'get' })

export const createRole = (data) =>
  request({ url: '/api/roles', method: 'post', data })

export const updateRole = (roleId, data) =>
  request({ url: `/api/roles/${roleId}`, method: 'put', data })

export const deleteRole = (roleId) =>
  request({ url: `/api/roles/${roleId}`, method: 'delete' })

export const copyRole = (roleId, data) =>
  request({ url: `/api/roles/${roleId}/copy`, method: 'post', data })

export const getUserRoles = (userId) =>
  request({ url: `/api/users/${userId}/roles`, method: 'get' })

export const setUserRoles = (userId, roleIds) =>
  request({ url: `/api/users/${userId}/roles`, method: 'put', data: { role_ids: roleIds } })

export const getUserEffectivePermissions = (userId) =>
  request({ url: `/api/users/${userId}/permissions/effective`, method: 'get' })

export const getTaskBoardVisibility = () =>
  request({ url: '/api/task-board-visibility', method: 'get' })

export const setUserTaskBoardVisibility = (userId, showOnTaskBoard) =>
  request({
    url: `/api/users/${userId}/task-board-visibility`,
    method: 'put',
    data: { show_on_task_board: !!showOnTaskBoard }
  })
